import React, { useState } from 'react';
import Wrapper from '../../components/Wrapper';
import { Button, Form, InputGroup, Spinner } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import axiosInstance from '../../utils/axios';

const UpdateReport = () => {
  // const dispatch = useDispatch();
  const { status } = useSelector((state) => state.sample);
  const [isProcessing, setIsProcessing] = useState('');
  const [searchKeyword, setSearchKeyword] = useState('');
  const [allSampleIds, setAllSampleIds] = useState([]);
  const [selectedLanguage, setSelectedLanguage] = useState('english');
  const [reportType, setReportType] = useState('full');

  const getReportBySampleId = async (sampleId) => {
    console.log('Getting report for sample ID:', sampleId);
    const response = await axiosInstance.get(`super-admin/report-with-sample-id/${sampleId}`);
    console.log('Report data:', response.data);
    return response.data;
  };


const downloadReport = async (sampleId, fullResponse) => {
  try {
    const url = reportType === 'full' 
        ? `/make-pdf/${selectedLanguage}` 
        : `/make-landscape-pdf/${selectedLanguage}`;

    const response = await axiosInstance.post(
      url,
      fullResponse || {},
      {
        withCredentials: true, 
        responseType: 'blob',      
        headers: {
          'Content-Type': 'application/json'
        }
      }
    );

    const blob = new Blob([response.data], { type: 'application/pdf' });
    const objectUrl = window.URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = objectUrl;
    a.download = `${sampleId}_${selectedLanguage}.pdf`;
    document.body.appendChild(a);
    a.click();
    a.remove();

    window.URL.revokeObjectURL(objectUrl);

  } catch (error) {
    console.error('Failed to download PDF:', error);
  }
};

  const processSampleIds = async (samplesToProcess) => {
    for (let i = 0; i < samplesToProcess.length; i++) {
      const sampleId = samplesToProcess[i].id;
      try {
        setAllSampleIds((prev) =>
          prev.map((sample, index) =>
            index === i ? { ...sample, status: 'in progress' } : sample
          )
        );
        const sampleDataRes = await getReportBySampleId(sampleId);
        await downloadReport(sampleId, sampleDataRes);
        setAllSampleIds((prev) =>
          prev.map((sample, index) =>
            index === i ? { ...sample, status: 'completed' } : sample
          )
        );
      } catch (error) {
        setAllSampleIds((prev) =>
          prev.map((sample, index) =>
            index === i ? { ...sample, status: 'error' } : sample
          )
        );
      }
    }
  }

  const handleProcess = async (e) => {
    if (e.type === 'click' || e.key === 'Enter') {
      setIsProcessing(true);
      const ids = searchKeyword
        .split(',')
        .map((id) => id.trim())
        .filter((id) => id !== '');

      const idsWithStatus = ids.map((id) => ({ id, status: 'pending' }));
      setAllSampleIds(idsWithStatus);
      console.log('Sample IDs to process:', ids);
      await processSampleIds(idsWithStatus);
      setIsProcessing(false);
    }
  };
  return (
    <Wrapper>
      <div className='d-flex flex-column justify-content-center align-items-center pt-4'>
        <h1>Bulk Download Reports</h1>
        <p className='text-danger'>with Sample id</p>

        {/* search bar */}
        <div className='w-100 mt-5'>
          <div className="d-flex justify-content-center mb-3 gap-4">
            <Form.Check
              type="radio"
              id="full-report"
              label="Full Report"
              name="reportType"
              value="full"
              checked={reportType === 'full'}
              onChange={(e) => setReportType(e.target.value)}
              disabled={isProcessing}
            />
            <Form.Check
              type="radio"
              id="landscape-report"
              label="1 Pager Report"
              name="reportType"
              value="landscape"
              checked={reportType === 'landscape'}
              onChange={(e) => setReportType(e.target.value)}
              disabled={isProcessing}
            />
          </div>
          <InputGroup className='mb-3 container-md w-70'>
            <Form.Select
              aria-label='Language selection'
              className='rounded-start rounded-end-0'
              style={{ maxWidth: '150px' }}
              value={selectedLanguage}
              onChange={(e) => setSelectedLanguage(e.target.value)}
            >
              <option value='english'>English</option>
              <option value='hindi'>Hindi</option>
              <option value='telugu'>Telugu</option>
              <option value='punjabi'>Punjabi</option>
              <option value='marathi'>Marathi</option>
              <option value='kannada'>Kannada</option>
              <option value='tamil'>Tamil</option>
              <option value='gujarati'>Gujarati</option>
              <option value='odia'>Odia</option>
              <option value='bengali'>Bengali</option>
            </Form.Select>
            <Form.Control
              placeholder='Enter Sample IDs (separated by comma)'
              aria-label='Enter Sample IDs (separated by comma)'
              value={searchKeyword}
              onChange={(e) => setSearchKeyword(e.target.value)}
              onKeyDown={handleProcess}
            />
            <Button
              variant='dark'
              id='button-addon2'
              className='rounded-end rounded-start-0'
              onClick={handleProcess}
              disabled={status === 'loading' || isProcessing}
            >
              {status === 'loading' && <Spinner size='sm' className='me-2' />}
              Process
            </Button>
          </InputGroup>
        </div>

        <div className='w-100 mt-4'>
          {allSampleIds.length > 0 && (
            <div className='container-md'>
              <h4>Sample IDs to be processed:</h4>
              <table className='table table-bordered'>
                <thead>
                  <tr>
                    <th>Sample ID</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {allSampleIds.map((sample, index) => (
                    <tr key={index}>
                      <td>{sample.id}</td>
                      <td>{sample.status}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </Wrapper>
  );
};

export default UpdateReport;
